<template>
  <div class="cont-box">
    <div class="form-box" v-show="modelCode === 1">
      <FormTitle :infoName="infoName" />
      <!-- <AdvertisingTitle class="h5-show" :contList="contList" v-show="modelCode === 1"/> -->

      <!-- 大纲生成条件 -->
      <div class="form-list" v-show="modelCode === 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-position="top"
          class="demo-ruleForm"
          @submit.native.prevent
        >
          <!-- 中屏 -->
          <el-form-item label="请输入论文标题" class="form-item-pc-show">
            <el-input
              v-model="ruleForm.title"
              style="position: relative; z-index: 11"
              type="text"
              placeholder="请输入完整的标题，标题越完整，创作内容越准确"
              @focus="openTitleInfo"
              maxlength="50"
            >
              <div
                class="btn-i-icon cursor-pointer"
                v-if="ruleForm.title.length"
                slot="suffix"
                @click="handleIconClick"
              >
                <svg
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9406"
                  width="20"
                  height="20"
                >
                  <path
                    fill="#2f6bf1"
                    d="M693.952 630.592l193.088 193.152-60.352 60.288L633.6 690.944l60.352-60.352zM614.4 72.512c12.8-4.224 29.888 4.288 29.888 17.088l34.112 226.112c4.288 4.288 4.288 8.576 4.288 12.8L819.2 486.4c8.512 8.512 8.512 25.6-8.512 29.888l-187.776 102.4c-4.224 4.224-8.512 4.224-8.512 8.512L490.688 832c-8.576 12.8-25.6 17.088-34.176 4.288l-153.6-174.976c-4.224-4.224-8.512-8.512-12.8-8.512L89.6 627.2c-12.8-4.288-21.312-17.088-17.088-29.888l89.6-196.224v-8.576l-25.6-226.112c-4.224-17.088 8.576-25.6 21.376-25.6l230.4 8.512H396.8z m-42.688 110.976l-145.024 51.2c-12.8 4.224-29.888 4.224-42.688 4.224L226.112 230.4 243.2 379.712c0 17.088 0 34.176-8.512 51.2l-51.2 123.776 119.424 12.8c25.6 0 51.2 12.8 68.288 34.112l93.888 110.912 81.024-128c8.576-17.024 21.376-29.824 38.4-38.4l119.488-64L618.688 384c-12.8-17.088-21.376-34.112-21.376-55.488l-25.6-145.024z"
                    p-id="9407"
                  ></path>
                </svg>
                <span>优化标题</span>
              </div>
            </el-input>
            <TitleInfoBox
              ref="TitleInfo"
              :title="ruleForm.title"
              :code="ruleForm.creationDocCode"
              @acceptTitle="acceptTitle"
            />
          </el-form-item>
          <!-- 小屏 -->
          <el-form-item label="请输入论文标题" class="form-item-h5-show">
            <el-input
              v-model="ruleForm.title"
              type="text"
              placeholder="标题越完整，创作内容越精准"
              maxlength="50"
            >
            </el-input>
          </el-form-item>

          <template v-if="thesisInfo.subjectList">
            <!-- 中屏 -->
            <el-form-item
              class="form-item-pc-show"
              label="请选择科目(没有所选专业请输入)"
            >
              <div class="show-panel" @click="showPanel('startPointId')">
                <el-input
                  v-model="ruleForm.extParam.subject"
                  placeholder="请输入或选择科目"
                  clearable
                ></el-input>
                <el-cascader
                  id="startPointId"
                  placeholder="请选择"
                  v-model="ruleForm.extParam.subject"
                  filterable
                  :options="thesisInfo.subjectList"
                  :props="{
                    label: 'name',
                    value: 'name',
                    children: 'children',
                    expandTrigger: 'hover',
                    emitPath: false,
                  }"
                  @blur="handleBlur"
                ></el-cascader>
              </div>
            </el-form-item>
            <!-- 小屏 -->
            <el-form-item
              class="form-item-h5-show"
              label="请选择科目(没有所选专业请输入)"
              v-if="thesisInfo.subjectList"
            >
              <div class="show-drawer">
                <el-input
                  v-model="ruleForm.extParam.subject"
                  placeholder="请输入科目"
                  clearable
                >
                  <el-button slot="append" @click.click="dialogDrawer">
                    选择科目<i class="el-icon-arrow-right"></i>
                  </el-button>
                </el-input>

                <DrawerH5 ref="Drawer" @subject="refChild" />
              </div>
            </el-form-item>
          </template>

          <el-form-item class="h5-form-item" label="请选择学历">
            <el-radio-group
              v-model="ruleForm.extParam.education"
              class="form-xl"
              @input="educationChange"
            >
              <el-radio
                v-for="item in thesisInfo.education"
                :key="'h5_education_' + item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item
            class="h5-form-item"
            label="请选择字数"
            v-if="thesisInfo.creationWordsNum"
          >
            <!-- 中屏 -->
            <el-radio-group
              v-model="ruleForm.extParam.creationWordsNum"
              class="radio-pc-show"
            >
              <el-radio-button
                v-for="item in thesisInfo.creationWordsNum"
                :key="'pc_words_num_' + item"
                :label="item"
                >{{ item + '字左右' }}</el-radio-button
              >
            </el-radio-group>
            <!-- 小屏 -->
            <el-radio-group
              v-model="ruleForm.extParam.creationWordsNum"
              class="radio-h5-show h5-el-radio"
            >
              <el-radio
                v-for="item in thesisInfo.creationWordsNum"
                :key="'h5_words_num_' + item"
                :label="item"
                >{{ item + '字左右' }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item class="h5-form-item" label="请选择大纲级别" v-if="thesisInfo.creationWordsNum">
          <el-radio-group v-model="questInfo.level">
            <el-radio label="二级">二级大纲</el-radio>
            <el-radio label="三级">三级大纲</el-radio>
          </el-radio-group>
        </el-form-item> -->
        </el-form>
      </div>

      <div class="form-btn" v-if="modelCode === 1">
        <el-checkbox class="form-check" v-model="btnInfo.checked">{{
          btnInfo.title
        }}</el-checkbox>
        <el-button
          style="width: 180px"
          type="primary"
          :disabled="!btnInfo.checked"
          @click="showSummary"
          >生成大纲</el-button
        >
      </div>

      <NoticeWrapper />
    </div>

    <!-- 大纲列表 -->
    <outline-edit
      v-if="modelCode === 2"
      ref="outlineRef"
      :level="questInfo.level"
      :level-change="levelChange"
      :subject-list="thesisInfo.subjectList"
      :summary-list="outlineList"
      :form-topic="ruleForm.title"
      :generate-paper="submitForm"
    ></outline-edit>

    <!-- 大纲加载状态 -->
    <div
      v-if="formLoading"
      class="loading-box full-height full-width column justify-center items-center"
    >
      <el-progress
        type="circle"
        :stroke-width="10"
        text-color="#20a0ff"
        :percentage="loadingPercent"
      ></el-progress>
      <div class="loading-text">AI正在思考中...</div>
    </div>
  </div>
</template>

<script>
import OutlineEdit from './outline/index.vue'
import ThesisApi from '@/api/thesis'
import CommonApi from '@/api/common'
import { orderMixin } from '@/utils/orderMixin'
import DrawerH5 from '@/components/drawerH5/drawerH5.vue'
import FormTitle from '@/components/FormTitle/index.vue'
// import AdvertisingTitle from '@/components/AdvertisingTitle/index.vue'
import NoticeWrapper from '@/components/NoticeWrapper'
import TitleInfoBox from '@/components/titleInfoBox/index.vue'
import { PAPER_CONFIRM_TIP } from '@/assets/constant.json'
// import { createOutline2 } from './outline/data.json'
export default {
  mixins: [orderMixin],
  props: ['infoName', 'contList'],
  components: {
    OutlineEdit,
    FormTitle,
    DrawerH5,
    // AdvertisingTitle,
    NoticeWrapper,
    TitleInfoBox,
  },
  data() {
    return {
      modelCode: 1, // 当前模式： 1 填写表单  2 编辑大纲
      ruleForm: {
        title: '',
        creationDocId: 1,
        creationDocCode: 'THESIS',
        channelCode: null,
        extParam: {
          version: 1,
          modelCode: 1,
          education: null,
          creationWordsNum: '',
          subject: '',
        },
      },
      btnInfo: {
        title: PAPER_CONFIRM_TIP,
        checked: true,
      },
      thesisInfo: {
        // 表单的options数据
        education: '',
        creationWordsNum: '',
        subjectList: [],
      },
      questInfo: {
        education: '', // 学历
        level: '二级', // 提纲级别*
        sign: '', // 签名*
        subject: '', // 科目*
        timestamp: '', // 时间戳
        title: '', // 标题*
        wordsNum: '', // 字数
      },
      outline: [],
      outlineList: [],
      finalText: '',
      shake: false,

      formLoading: false, //AI搜索加载
      loadingPercent: 0, // 大纲加载进度
      loadingInterval: null, // 大纲进度定时器
    }
  },
  watch: {
    formLoading(val) {
      // 大纲加载状态处理
      if (val) {
        this.loadingInterval = setInterval(() => {
          this.loadingPercent += 1
          // 后端数据未返回，则进度条不停止
          this.loadingPercent >= 99 && this.clearLoading()
        }, 120) // 预计12秒加载完数据
      } else {
        this.clearLoading()
        this.loadingPercent = 0
      }
    },
  },
  created() {
    this.getEducation()
    this.getSubject()
  },
  provide() {
    return {
      showSummary: this.showSummary,
      modelChange: this.modelChange,
    }
  },
  methods: {
    clearLoading() {
      // 清除进度定时器
      if (this.loadingInterval) {
        clearInterval(this.loadingInterval)
        this.loadingInterval = null
      }
    },
    levelChange(level) {
      // 设置大纲
      this.questInfo.level = level
    },
    thesisSearchBtn(extralParam, callback) {
      // extralParam: { num: 接口需要返回的大纲个数, level: 大纲级别 }
      if (this.ruleForm.title === '') {
        return this.$message({
          message: '请输入论文标题',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      } else if (this.ruleForm.title.length < 5) {
        return this.$message({
          message: '标题长度需要至少5个字!',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      }
      if (this.shake === true) {
        return this.$message.success('请给AI一点时间...')
      }
      this.shake = true
      this.questInfo.education = this.ruleForm.extParam.education
      this.questInfo.subject = this.ruleForm.extParam.subject
      this.questInfo.title = this.ruleForm.title
      this.questInfo.wordsNum = this.ruleForm.extParam.creationWordsNum

      let time = new Date().getTime()
      let setOf =
        this.ruleForm.title +
        this.ruleForm.extParam.subject +
        time +
        this.ruleForm.extParam.education +
        this.questInfo.level +
        time +
        time +
        this.ruleForm.extParam.creationWordsNum
      let infoMd5 = this.$md5(setOf)
      this.questInfo.sign = infoMd5
      this.questInfo.timestamp = time

      const params = Object.assign({}, this.questInfo, extralParam || {})
      //  查询 - AI
      this.createOutline(params, callback)
      this.formLoading = true
    },

    // 获取ai接口
    createOutline(data, callback) {
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      ThesisApi.createOutline(data, key, time, infoMd5)
        .then((res) => {
          this.outlineList = res.data || []

          typeof callback === 'function' && callback()

          // // 关闭加载
          // this.formLoading = false
          // // 关闭防抖
          // this.shake = false
        })
        .catch(() => {
          // 关闭加载
          this.formLoading = false
          // 关闭防抖
          this.shake = false
        })
    },
    // 监听标准版/专业版切换
    // 选择学历
    clickNav(index) {
      // this.ruleForm.extParam.creationWordsNum = ''
      // this.thesisInfo.creationWordsNum = ''
      this.thesisInfo.education.forEach((item) => {
        item.active = 0
      })
      this.thesisInfo.education[index].active = 1
      // this.ruleForm.extParam.education = this.thesisInfo.education[index].value
      let num = this.thesisInfo.education[index].value
      this.getWordsNum(num)
    },
    // 选择学历
    educationChange(val) {
      // this.ruleForm.extParam.creationWordsNum = ''
      // this.thesisInfo.creationWordsNum = ''

      // 硕士默认三级大纲，非硕士默认二级大纲
      this.levelChange(val === 3 ? '三级' : '二级')

      this.getWordsNum(val)
    },
    // 获取学历接口
    getEducation() {
      ThesisApi.getEducation()
        .then((res) => {
          let dataList = res.data
          dataList.forEach((item) => {
            item.active = 0
          })
          if (dataList.length >= 3) {
            dataList[0].tip =
              '清晰架构，内容丰富的基础设计，确保每处细节与数据都精准无误。'
            dataList[1].tip =
              '强化逻辑思维，深挖理论精髓，广纳多元主题，达成高水平分析力。'
            dataList[2].tip =
              '潜心研究，力求创新，深挖精髓，打造原创性高、研究价值深厚的文章。'
          }
          this.thesisInfo.education = dataList
          // 触发默认选中学历
          this.clickNav(1)
        })
        .catch(() => {})
    },
    // 获取科目
    getSubject() {
      CommonApi.getSubject()
        .then((res) => {
          this.thesisInfo.subjectList = res.data
          // 默认选中的科目
          // this.ruleForm.extParam.subject = '计算机科学与技术类'
        })
        .catch(() => {})
    },
    // 获取字数
    getWordsNum(num) {
      ThesisApi.getWordsNum(num)
        .then((res) => {
          this.thesisInfo.creationWordsNum = res.data
          // 保持数据一致
          // 默认选中项 num - 1
          this.ruleForm.extParam.education =
            this.thesisInfo.education[Number(num - 1)].value
          // 默认选中第2项 index = 1
          this.ruleForm.extParam.creationWordsNum =
            this.thesisInfo.creationWordsNum[1]
        })
        .catch(() => {})
    },
    showSummary() {
      // 切换到编辑大纲，并查询大纲
      this.outlineList = [] // 先清除大纲数据

      if (this.checkForm()) {
        return
      }
      this.thesisSearchBtn({ num: 1 }, () => {
        // 大纲数据已返回，进度条快速结束
        //    1.进度条还在加载中，则快速结束
        //    2.进度条已结束，则直接切换到大纲展示模式
        if (this.loadingPercent < 98) {
          // 进度小于98，先快进到100，再切换到大纲展示模式
          this.clearLoading()
          this.loadingInterval = setInterval(() => {
            // 快速结束进度条：每次+2，速度加快到50ms
            this.loadingPercent += 2
            if (this.loadingPercent >= 100) {
              this.clearLoading()
              this.$nextTick(() => {
                // 切换到大纲展示模式
                this.modelChange(2)
              })
            }
          }, 50)
        } else {
          // 进度98以上，可忽略，直接进入大纲
          this.loadingPercent = 100
          this.$nextTick(() => {
            // 切换到大纲展示模式
            this.modelChange(2)
          })
        }
      })

      // this.formLoading = true
      // this.shake = true
      // setTimeout(() => {
      //   this.outlineList = createOutline2.data || []
      //   // 关闭加载
      //   if (this.loadingPercent < 96) {
      //     this.clearLoading()
      //     this.loadingInterval = setInterval(() => {
      //       this.loadingPercent += 2
      //       if (this.loadingPercent >= 100) {
      //         this.clearLoading()
      //         // 搜索大纲结束，切换到大纲展示模式
      //         this.$nextTick(() => {
      //           this.modelChange(2)
      //         })
      //       }
      //     }, 50)
      //   } else {
      //     this.loadingPercent = 100
      //     this.$nextTick(() => {
      //       this.modelChange(2)
      //     })
      //   }
      // }, 8000)
    },
    modelChange(val = 1) {
      // 切换 表单/大纲 页面
      // 关闭加载
      this.formLoading && (this.formLoading = false)
      // 关闭防抖
      this.shake && (this.shake = false)

      this.modelCode = val

      // 表单页面，重置大纲级别
      if (val === 1) {
        this.levelChange(
          this.ruleForm.extParam.education === 3 ? '三级' : '二级'
        )
      }
    },
    checkForm() {
      // 检查表单是否填写完整且正确：null，表示检查通过，可继续下一步逻辑
      if (this.ruleForm.title === '') {
        return this.$message({
          message: '请输入论文标题',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      } else if (this.ruleForm.title.length < 5) {
        return this.$message({
          message: '标题长度需要至少5个字!',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      }
      if (this.ruleForm.extParam.subject === '') {
        return this.$message({
          message: '请输入或选择科目!',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      }
      if (this.ruleForm.extParam.creationWordsNum === '') {
        return this.$message({
          message: '请选择字数!',
          type: 'warning',
          duration: 2000,
          customClass: 'focus-message',
        })
      }

      return null
    },
    submitForm() {
      let _this = this
      if (_this.checkForm()) {
        return
      }

      // 获取修改后的大纲数据
      const outline = this.$refs.outlineRef.getSummaryContent()
      this.ruleForm.extParam.outline = JSON.parse(
        JSON.stringify(outline, ['title', 'children', 'chartAndTable'])
      )

      let data = JSON.parse(JSON.stringify(_this.ruleForm))
      let info = JSON.stringify(data.extParam)
      data.extParam = info
      //生成订单 mixin
      _this.createOrder(data, data)
    },
    // 打开隐藏的 科目选择器
    showPanel(val) {
      document.getElementById(val).click()
    },
    handleBlur(e) {
      this.ruleForm.extParam.subject = e.target.value
    },
    // 移动端 选择科目 组件相关
    dialogDrawer() {
      let params = {
        show: true,
        info: this.thesisInfo,
      }
      this.$refs.Drawer.showDrawer(params)
    },
    refChild(name) {
      this.ruleForm.extParam.subject = name
    },
    openTitleInfo() {
      this.$refs.TitleInfo.openItme()
    },
    acceptTitle(item) {
      this.ruleForm.title = item
    },
    handleIconClick() {
      this.$refs.TitleInfo.optimize()
    },
  },
}
</script>

<style lang="less" scoped>
@import '@/assets/css/pageContent';
.form-item-pc-show {
  display: block;
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.form-item-h5-show {
  display: none;
  @media screen and (max-width: 900px) {
    display: block;
  }
}
.show-panel {
  max-width: 100% !important;
  #startPointId {
    width: 100%;
  }
}

.loading-box {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  top: 0;
  z-index: 999;
  .loading-text {
    color: #20a0ff;
    margin-top: 8px;
  }
}
</style>
